module.exports = __webpack_public_path__ + "static/media/6.6c181fdb.JPG";